// extracted by mini-css-extract-plugin
module.exports = {"starsubTitle":"_0a9d3f1","starsubTitleBadge":"_533a236"};